import { Component, OnInit, Input, HostListener, Output, EventEmitter } from "@angular/core";

import { TABLET_SIZE, DESKTOP_SIZE, WIDESCREEN_SIZE } from "../settings";

export interface SelectButton {
  currentId?: string;
  name?: string;
  label: string;
  description?: string;
  isSelected: Function;
  imageSrc: string;
  imageSrcAction?: Function;
  clickAction: Function;
  deleteAction?: Function;
  goToAction?: Function;
  message?: string;
  extenderActive?: boolean;
  textTop?: string;
  extenderMessage?: string;
  hidden?: boolean;
  hasError?: boolean;
  isLoading?: boolean | Function;
}

@Component({
  selector: "app-horizontal-select-button",
  templateUrl: "./horizontal-select-button.component.html",
  styleUrls: ["./horizontal-select-button.component.scss"],
  standalone: false
})
export class HorizontalSelectButtonComponent {
  @Input() iconSrc: string;
  @Input() title: string;
  @Input() description: string;
  @Input() isActive: boolean = false;
  @Output() onClick = new EventEmitter<void>();

  public handleOnClick(): void {
    this.onClick.emit();
  }
}
